import { ServiceHelper2 } from "../../Common/_helpers/ServiceHelper2";
import { BUDGETS_API_URLS } from "../_constants/url.constants";

export const DevicesService = {
    getDeviceByBluetoothId,
};

async function getDeviceByBluetoothId(bluetoothId) {
    return await ServiceHelper2.getRequest(
        BUDGETS_API_URLS.DISTRIBUTOR_DEVICES + "/" + encodeURIComponent(bluetoothId),
    );
}